import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { siteInfo } from "@/mocks/siteInfo";

const navItems = [
  { label: "首页", to: "/" },
  { label: "剧集", to: "/episodes" },
  { label: "角色", to: "/characters" },
  { label: "资讯", to: "/news" },
  { label: "关于", to: "/about" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
    setMobileOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-movie-2-line text-lg"></i>
          </span>
          <span className="font-heading text-base font-extrabold tracking-tight text-foreground-950 md:text-lg">
            {siteInfo.name}
          </span>
        </Link>

        <nav className="hidden flex-1 items-center justify-center gap-1 md:flex">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`rounded-md px-3 py-2 font-label text-sm transition-colors ${
                isActive(item.to)
                  ? "bg-primary-50 font-semibold text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <form onSubmit={submitSearch} className="ml-auto hidden items-center lg:flex">
          <div className="relative">
            <span className="pointer-events-none absolute left-3 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="search"
              placeholder="搜索剧集、角色、资讯"
              aria-label="站内搜索"
              className="h-10 w-56 rounded-full border border-background-300 bg-background-100 pl-9 pr-4 font-label text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50 focus:ring-2 focus:ring-primary-100"
            />
          </div>
        </form>

        <button
          type="button"
          aria-label="展开导航菜单"
          onClick={() => setMobileOpen((v) => !v)}
          className="ml-auto flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 md:hidden"
        >
          <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-4 md:hidden">
          <form onSubmit={submitSearch} className="relative mb-4">
            <span className="pointer-events-none absolute left-3 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="search"
              placeholder="搜索剧集、角色、资讯"
              aria-label="站内搜索"
              className="h-11 w-full rounded-full border border-background-300 bg-background-100 pl-9 pr-4 font-label text-sm text-foreground-950 outline-none placeholder:text-foreground-400 focus:border-primary-400"
            />
          </form>
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMobileOpen(false)}
                className={`rounded-md px-3 py-3 font-label text-sm transition-colors ${
                  isActive(item.to)
                    ? "bg-primary-50 font-semibold text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}